/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsqueryRecommendationsRecommendUserIdGet$Plain$Params {
  userId: string;
}

export function apiProductsqueryRecommendationsRecommendUserIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsqueryRecommendationsRecommendUserIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryRecommendationsRecommendUserIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsqueryRecommendationsRecommendUserIdGet$Plain.PATH = '/api/productsquery/recommendations/recommend/{userId}';
